module.exports = __webpack_public_path__ + "static/media/Mama Rochel - Napping Agreement.698946b8.pdf";